export function multiplier(index, offset, startValue=0) {
  return ((index * offset) + startValue).toFixed(2);
};
